import { render, staticRenderFns } from "./NominasView.vue?vue&type=template&id=bef73ec6&"
import script from "./NominasView.vue?vue&type=script&lang=js&"
export * from "./NominasView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports